<template>
  <router-link v-if="show" :to="`create${createId ? '/' + createId : ''}`">
    <el-tooltip :content="name" placement="right" effect="light">
      <el-button
        type="primary"
        size="medium"
        icon="el-icon-edit-outline"
        circle
      />
    </el-tooltip>
  </router-link>
</template>

<script>
export default {
  name: "ButtonCreate",
  props: {
    createId: {
      type: [Number, String],
      default: "",
    },
    show: {
      type: Boolean,
      default: false,
    },
    name: {
      type: String,
      default: "Создать",
    },
  },
};
</script>
